import { type CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { InjectionToken } from '@angular/core';

export interface ScrollOffsetAdapter {
  measureScrollOffset(viewport: CdkVirtualScrollViewport): number;
}

export const BLAZE_SCROLL_OFFSET_ADAPTER = new InjectionToken('BLAZE_SCROLL_OFFSET_ADAPTER', {
  factory: (): ScrollOffsetAdapter => {
    return new DefaultScrollOffsetAdapter();
  },
});

export class DefaultScrollOffsetAdapter implements ScrollOffsetAdapter {
  measureScrollOffset(viewport: CdkVirtualScrollViewport): number {
    return Math.max(0, viewport.measureScrollOffset());
  }
}
